import type { SiteConfig } from '@/types'

import { getOrigin } from '@/lib/window'
import { OG_DEFAULT } from '@/constants/media'

export const siteConfig: SiteConfig = {
    name: 'Svenn',
    description: "Svenn samler befaring, kalkulasjon, prosjektstyring, KS, HMS og timeføring i én løsning for håndverkere. Bygg overskudd fra første spiker. Prøv gratis i 14 dager.",
    url: getOrigin(),
    ogImage: OG_DEFAULT
}

export const CONTACT = {
    email: 'support@svenn.com',
    phone: '95 45 67 40',
    phoneHref: 'tel:+4795456740',
    street: 'Skippergata 9',
    city: '0152 Oslo',
    address: 'Skippergata 9, 0152 Oslo',
    hours: "Mandag til fredag, 08 til 16",
    mapsHref: 'https://www.google.com/maps/search/?api=1&query=Skippergata+9%2C+0152+Oslo'
} as const

export const LINKS = {
    signup: 'https://svenn.com/no/sign-up',
    login: 'https://web.svenn.com',
    help: 'https://service.svenn.com/help',
    privacy: 'https://svenn.com/personvern',
    forgotPassword: 'https://web.svenn.com/auth/forgot-password',
    youtube: 'https://www.youtube.com/@svenn-com/videos',
    linkedin: 'https://www.linkedin.com/company/svenn/',
    instagram: 'https://www.instagram.com/svenn_com/',
    facebook: 'https://www.facebook.com/SvennNorgeAS',
    careersEmail: 'sondre@svenn.com'
} as const

export const TRIAL_POINTS = [
    "14 dager helt gratis",
    "Krever ikke kredittkort",
    "Ingen auto-abonnement",
    "I gang på 2 minutter"
] as const
